import React from 'react';
import {useTranslation} from 'react-i18next';
import {FaIcon} from '../../FaIcon';

export function ExplainerSection({isClientView}) {
    const {t} = useTranslation();

    const cards = [
        {icon: 'comments', titleKey: 'dashbo_mcp.explainer.card_query_title', descKey: 'dashbo_mcp.explainer.card_query_desc'},
        {icon: 'plug', titleKey: 'dashbo_mcp.explainer.card_integrate_title', descKey: 'dashbo_mcp.explainer.card_integrate_desc'},
        {icon: 'code', titleKey: 'dashbo_mcp.explainer.card_api_title', descKey: 'dashbo_mcp.explainer.card_api_desc'},
    ];

    return (
        <div className="dashbo-mcp-section">
            <h2 className="section-title">{t(isClientView ? 'dashbo_mcp.client.explainer_title' : 'dashbo_mcp.explainer.title')}</h2>
            <p className="section-description">{t(isClientView ? 'dashbo_mcp.client.explainer_description' : 'dashbo_mcp.explainer.description')}</p>
            <div className="explainer-cards">
                {cards.map((card, i) => (
                    <div key={i} className="explainer-card">
                        <div className="card-icon"><FaIcon iconName={card.icon}/></div>
                        <h4>{t(card.titleKey)}</h4>
                        <p>{t(card.descKey)}</p>
                    </div>
                ))}
            </div>
        </div>
    );
}
